import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AuthService } from './auth.service';
import { firestore } from 'firebase/app';
import { map, switchMap } from 'rxjs/operators';
import { Observable, combineLatest, of } from 'rxjs';
import { SharedService } from "./shared.service";
import * as moment from "moment-timezone";

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  constructor(
    private afs: AngularFirestore,
    private auth: AuthService
  ) {}

  getHistories() {
    const compareField = this.auth.user.role === AuthService.USER_ROLE ? 'user_id' : 'vtuber_id';

    return this.afs
        .collection('histories', ref => ref.where(compareField, '==', this.auth.user.uid).orderBy('createdAt', 'desc'))
        .snapshotChanges()
        .pipe(
        map(actions => {
            return actions.map(a => {
                const data: Object = a.payload.doc.data();
                const id = a.payload.doc.id;

                return { id, ...data };
                });
            })
        );
  }

  getCurrentMonthBalance(histories$: Observable<any>) {
    let currentMonth = moment().tz('Asia/Tokyo').format('Y-MM');
    return histories$.pipe(
        map(arr => {
            let sum = 0;
            arr.map(item => {
                if (moment(item.createdAt).format("Y-MM") === currentMonth) {
                    sum += Math.ceil(parseInt(item.plan.amount) * 81.4 / 100)
                }
            })

            return sum;
        })
    )
  }

  getData(histories$: Observable<any>) {
    let histories = [];
    const joinKeys = {};

    return histories$.pipe(
        switchMap(c => {
            histories = c;
            let uids = [];
            histories.map(history => {
                if (this.auth.user.role === AuthService.USER_ROLE) {
                    if (!uids.includes(history.vtuber_id)) {
                        uids.push(history.vtuber_id)
                    }
                }
                if (this.auth.user.role === AuthService.VTUBER_ROLE) {
                    if (!uids.includes(history.user_id)) {
                        uids.push(history.user_id)
                    }
                }
            })

            // Firestore User Doc Reads
            const userDocs = uids.map(u =>
                this.afs.doc(`users/${u}`).valueChanges()
            );

            return userDocs.length ? combineLatest(userDocs) : of([]);
        }),
        map(arr => {
            arr.forEach(v => (joinKeys[(<any>v).uid] = v));
            return histories.map(history => {
                let uid = this.auth.user.role === AuthService.USER_ROLE ? history.vtuber_id : history.user_id;

                history.user = {
                    photoURL: joinKeys[uid].photoURL,
                    displayName: joinKeys[uid].displayName
                }

                return history;
            })
        })
    )
  }
}
